import React, { PropTypes } from 'react'
import cx from 'classnames'

import './LabeledIcon.scss'

const LabeledIcon = (props) => {
  const {
    selected,
    onClick,
    iconType,
    iconContent,
    label
  } = props

  const wrapperClassName = cx(
    'LabeledIcon',
    {
      'is-selected': selected,
      'LabeledIcon-clickable': !!onClick,
    }
  )

  return (
    <span className={wrapperClassName} onClick={onClick}>
      <span className='LabeledIcon-wrapper'>
        {
          iconType === 'text'
            ? (<span className='LabeledIcon-text'>{iconContent}</span>)
            : (<span className={`LabeledIcon-icon icon-${iconContent}`} />)
        }
      </span>
      {label && (<span className='LabeledIcon-label'>{label}</span>)}
    </span>
  )
}
LabeledIcon.displayName = 'LabeledIcon'
LabeledIcon.propTypes = {
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  iconType: PropTypes.oneOf(['icon', 'text']).isRequired,
  iconContent: PropTypes.string.isRequired,
  label: PropTypes.string
}
LabeledIcon.defaultProps = {
  selected: false,
  onClick: () => {},
  iconType: 'icon',
  iconContent: 'logo'
}

export default LabeledIcon



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/LabeledIcon/LabeledIcon.js